/**
 * The placeholder text to display when no option is selected.
 */
export const EMPTY_SELECT_TEXT = "- Select -";
